﻿/*
 * Created on Mon Nov 19 2018
 *
 * Copyright (c) 2018 - Francisco Giana <gianafrancisco@gmail.com>
 */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { CovetcbaRequest, RestorePasswordRequest, ResetPasswordRequest, RestorePasswordResponse } from '../_models';
import { sha256 } from 'js-sha256';
import { environment } from '../../environments/environment';
import jwt_decode  from 'jwt-decode';

@Injectable({ providedIn: 'root' })
export class AuthenticationService {

    private idmenuweb: number = 0;
    private comunicacion: boolean = false;

    constructor(private http: HttpClient) { 
        let currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
        if(currentUser != undefined) {
            let kermetPayload: {} = jwt_decode<any>(currentUser.token)['kermetPayload'];
            this.idmenuweb = kermetPayload['idmenuweb'];
            // this.comunicacion = kermetPayload['flag_comunicacion'];
        }
    }

    login(username: string, password: string) {

        const request = new CovetcbaRequest();
        const h1 = sha256(username.toLocaleLowerCase() + ' ' + password);
        request.usuario = username.toLocaleLowerCase();
        request.nonce = Date.parse("2099/05/28 00:00:00");
        // request.nonce = Math.ceil(Date.now());
        request.hash = sha256( request.nonce + ' ' + h1);
        console.log(request.hash);
        return this.http.post<any>(environment.apiUrl + '/jwt/login',  request )
            .pipe(map(user => {
                // login successful if there's a jwt token in the response
                if (user && user.token) {
                    console.log(user);
                    sessionStorage.setItem('currentUser', JSON.stringify(user));
                    let kermetPayload: {} = jwt_decode<any>(user.token)['kermetPayload'];
                    this.idmenuweb = kermetPayload['idmenuweb'];
                    // TODO: Uncomment this when comunicaciones has been implemented.
                    // this.comunicacion = kermetPayload['comunicaciones'];
                }

                return user;
            }));
    }

    restore(email: string) {
        const request = new RestorePasswordRequest();
        request.email = email;
        return this.http.post<RestorePasswordResponse>(environment.apiUrl + '/jwt/restore',  request );
    }

    reset(username: string, password: string, resetid: string) {

        const request = new ResetPasswordRequest();
        request.resetid = resetid;
        request.usuario = username.toLocaleLowerCase();
        request.nonce = Date.parse("2099/05/28 00:00:00");
        request.hash = sha256(username.toLocaleLowerCase() + ' ' + password);;
        return this.http.post<any>(environment.apiUrl + '/jwt/restore',  request );
    }

    logout() {
        // remove user from local storage to log user out
        sessionStorage.removeItem('currentUser');
        sessionStorage.removeItem('matriculado');
    }

    isDistrubuidora(): boolean {
        return this.idmenuweb == 1;
    }

    isMatriculado() {
        return this.idmenuweb == 0;
    }

    showComunicacion() {
        return this.comunicacion;
    }
    setComunication(val: boolean) {
        this.comunicacion = val;
    }

    get_user() {
        let currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
        if(currentUser != undefined) {
            let kermetPayload: {} = jwt_decode<any>(currentUser.token)['kermetPayload'];
            return kermetPayload['usuario'];
        }
        return null;
    }
}
